import React, { useEffect, useState } from "react";
// import { useUser } from "../context/user.context";

const Footer = ({ userData, onSubmit }) => {
  const [formData, setFormData] = useState(userData);

  // const { userData, setUserData } = useUser();



  // const setWindow = (windowState) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     windowVisible: windowState,
  //   }));

  //   onSubmit();
  // };

  return (
    <div className="footer">
      Cubic | Vehicle Interface Unit | Version 1.0.0
      <div className="footer-user-details">
        {userData?.isComplete() ? (
          <span onClick={() => onSubmit()}>
            {userData.lastName}, {userData.callsign}
          </span>
        ) : (
          <span onClick={() => onSubmit()}>Not Signed In</span>
        )}

      </div>
    </div>
  );
};

export default Footer;
